import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../../registration.service';
import { HandleError } from '../../../shared/HandleError';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-station-form',
  templateUrl: './station-form.component.html',
  styleUrls: ['./station-form.component.css']
})
export class StationFormComponent implements OnInit {
   maintitle="Stations";
  title = "Add Stations";
   s: any = {};
   formInvalid: boolean = false;
   data: any={};
   Station_Id:any;
   mode: string = "save";
  formSubmitted: boolean;

  constructor(private service: RegistrationService,private handleError:HandleError,private router: Router, private route: ActivatedRoute) { }
  ngOnInit() {
    
  this.mode=localStorage.getItem('mode');
  this.Station_Id= localStorage.getItem('Station_Id');
  localStorage.removeItem('Station_Id'); 
  localStorage.removeItem('mode');
  
  if (this.Station_Id != null && this.mode!=null) 
    this.GetStationsById(this.Station_Id);
  }

  SaveStations(stations: NgForm) {    
    
       if (stations.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.savestations(stations.value);
      this.data.subscribe(
        (response) => {
          stations.reset();
          stations.resetForm();       
           swal('Success!', 'Stations details saved Successfully .', 'success');
          this.router.navigate(['/home/Stations']) ;   
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.handleError.ErrorHandler(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }

      GetStationsById(Station_Id)
      {
        document.getElementById('loader-spinner').style.display = "block";
        this.service.getstationsById(Station_Id)
          .subscribe(
            (response:any) => {
              //this.AccountHeadDetails = data;  
              this.s = response.Result;    
              document.getElementById('loader-spinner').style.display = "none";
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              this.handleError.ErrorHandler(error);
            });
      }


      
      Reset(stations)
      {    
        stations.reset();
      }

      //Update
      UpdateStationsById(stations: NgForm) {
        if (!stations.invalid) {
        document.getElementById('loader-spinner').style.display = "block";
        this.service.updateStationsById(stations.value,this.Station_Id)
          .subscribe(
            (data) => {
              document.getElementById('loader-spinner').style.display = "none";
              swal('','Updated Successfully!','success');
              this.router.navigate(['/home/Stations']); 
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              this.handleError.ErrorHandler(error);
              //swal('Warning!', error.error.Message, 'warning');
            });
          }else{
            document.getElementById('loader-spinner').style.display = "none";
            swal('warning','Please fill all the mandatory fields!','warning');
            this.formSubmitted = true;
      
            }
      }

  
 }



// WEBPACK FOOTER //
// ./src/app/Masters/Stations/station-form/station-form.component.ts